<template>
  <j-page>
    <div class="enc-encrypt-textarea" slot="table">
      <div class="textarea-left">
        <j-dictionary type="select" api="/api/dictionaryItems/PROJECT_AREA/items-parent-key" placeholder="请选择区域" v-model="projectArea" clearable/>
        <el-input type="textarea" placeholder="处理内容" v-model="value" clearable/>
      </div>
      <div class="textarea-center">
        <el-button :disabled="projectArea.length < 1 || value.length < 1 " @click="encryptEvent" :loading="loading">加密</el-button>
        <el-button :disabled="projectArea.length < 1 || value.length < 1 " @click="decryptEvent" :loading="loading">解密</el-button>
        <el-button @click="projectArea = '';value = '';result = '';">重置</el-button>
      </div>
      <div class="textarea-right">
        <!--                <el-input style="height: 100%" type="textarea" placeholder="解密结果" v-model="result"/>-->
        <JsonViewer :value="result" expanded copyable :expand-depth="10" />
      </div>
    </div>
  </j-page>
</template>

<script>
import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
import JsonViewer from 'vue-json-viewer'
export default {
  name: "JEncEncrypt",
  mixins: [PageMixins],
  components: {
    JsonViewer
  },
  data() {
    return {
      loading: false,
      projectArea: '',
      value: '',
      result: '',
      projectAreaDic: [
        { key: 'YC', value: '宜昌' },
        { key: 'NMG', value: '内蒙古扎赉特' },
        { key: 'NXJF', value: '宁夏金凤' },
        { key: 'NXQTX', value: '宁夏青铜峡' },
        { key: 'NXTX', value: '宁夏同心' },
        { key: 'NXLT', value: '宁夏利通' },
        { key: 'ZWSPT', value: '中卫沙坡头' },
        { key: 'SDLX', value: '山东莱西' },
        { key: 'DWK', value: '大武口' },
        { key: 'NXGY', value: '宁夏固原' },
        { key: 'NXXX', value: '宁夏西夏' },
        { key: 'SXCZ', value: '山西长治' },
        { key: 'XJALE', value: '新疆阿拉尔' },
        { key: 'QZ', value: '海南琼中' },
        { key: 'SDLS', value: '山东崂山' },
        { key: 'DL', value: '天津东丽' },
        { key: 'SGRID', value: '标准版' },
        { key: 'NACOS', value: 'nacos标准版' },
        { key: 'BJNY', value: '北京南苑' },
        { key: 'NX', value: '宁夏' },
        { key: 'WZLT', value: '吴忠利通' },
        { key: 'XZND', value: '西藏乃东' },
        { key: 'XZQJ', value: '西藏琼结' },
        { key: 'HBSZ', value: '湖北随州' },
        { key: 'XZQS', value: '西藏拉萨曲水' },
        { key: 'FJJN', value: '福建建宁' },
        { key: 'SDDY', value: '山东东营' },
        { key: 'XZLS', value: '西藏拉萨' },
        { key: 'XZCN', value: '西藏错那' },
        { key: 'NK', value: '天津南开' },
        { key: 'BJKD', value: '北京看丹' },
        { key: 'YCZFBZ', value: '宜昌住房保障' },
        { key: 'XZDZ', value: '西藏达孜' },
        { key: 'YCYQFK', value: '宜昌疫情防控' },
        { key: 'HBYX', value: '河北蔚县' },
        { key: 'YCQZX', value: '宜昌情指行' }
      ]
    }
  },
  methods: {
    async encryptEvent () {
      if (this.loading) return
      this.loading = true
      const { data } = await this.$http.post('/isv/accounts/nacos-encrypt', {
        projectArea: this.projectArea.toUpperCase(),
        value: this.value.replace(/^"|"$/g, '')
      }).finally(() => {
        this.loading = false
      })
      this.result = data.data
    },
    async decryptEvent () {
      if (this.loading) return
      this.loading = true
      const { data } = await this.$http.post('/isv/accounts/nacos-decrypt', {
        projectArea: this.projectArea.toUpperCase(),
        value: this.value.replace(/^"|"$/g, '')
      }).finally(() => {
        this.loading = false
      })
      this.result = data.data
    }
  }
}
</script>

<style lang="scss">
.enc-encrypt-textarea {
  display: flex;
  .el-textarea__inner {
    height: 100%;
    resize:none;
  }
  .textarea-left {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .el-textarea {
      flex: 1;
      min-height: 100px;
    }
  }
  .textarea-left, .textarea-right {
    flex: 1;
    min-width: 100px;
  }
  .textarea-right {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    overflow: auto;
  }
  .textarea-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 5px;
    .el-button {
      margin: 5px 0;
    }
  }
}
</style>
